<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <section id="ngx-datatable-shipping">
            <div class="card">
                <div class="card-title d-flex justify-content-start align-items-center">
                    <button type="button" class="btn btn-icon btn-outline-primary" rippleEffect (click)="Back()">
                        <span [data-feather]="'arrow-left'"></span></button>
                    <h4 class="ml-50">{{isEditMode ? 'Editar' : 'Nueva'}} Factura</h4>
                </div>
            </div>
            <div class="card-body">
                <div id="stepper2" class="bs-stepper vertical vertical-wizard-example">
                    <div class="bs-stepper-header">
                        <div class="step" data-target="#origin">
                            <button type="button" class="step-trigger">
                                <span class="bs-stepper-box">1</span>
                                <span class="bs-stepper-label">
                                    <span class="bs-stepper-title">Origen</span>
                                    <span class="bs-stepper-subtitle">Quien envía</span>
                                </span>
                            </button>
                        </div>
                        <div class="step" data-target="#destination">
                            <button type="button" class="step-trigger">
                                <span class="bs-stepper-box">2</span>
                                <span class="bs-stepper-label">
                                    <span class="bs-stepper-title">Destino</span>
                                    <span class="bs-stepper-subtitle">Hacia donde se envía</span>
                                </span>
                            </button>
                        </div>
                        <div class="step" data-target="#details">
                            <button type="button" class="step-trigger">
                                <span class="bs-stepper-box">3</span>
                                <span class="bs-stepper-label">
                                    <span class="bs-stepper-title">Detalles</span>
                                    <span class="bs-stepper-subtitle">Detalles de la factura</span>
                                </span>
                            </button>
                        </div>
                        <div class="step" data-target="#confirmation">
                            <button type="button" class="step-trigger">
                                <span class="bs-stepper-box">4</span>
                                <span class="bs-stepper-label">
                                    <span class="bs-stepper-title">Confirmación</span>
                                    <span class="bs-stepper-subtitle">Información de la factura</span>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div class="bs-stepper-content">
                        <div id="origin" class="content">
                            <div class="content-header">
                                <h5 class="mb-0">Origen</h5>
                                <small class="text-muted">Puede realizar la búsqueda por número de teléfono.</small>
                            </div>
                            <form [formGroup]="senderForm">
                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label class="form-label" for="vertical-phone">
                                            <b class="text-primary">*</b> Teléfono
                                        </label>
                                        <div class="input-group">
                                            <input #senderNumberPhone type="text" class="form-control"
                                                (keypress)="NumberOnly($event)" formControlName="senderPhone"
                                                placeholder="555-5555"
                                                (keyup.enter)="SearchSenderByNumber(senderNumberPhone.value)"
                                                maxlength="11" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                                aria-describedby="button-addon2" [readonly]="isEditMode" />
                                            <div class="input-group-append" id="button-addon2">
                                                <button class="btn btn-outline-primary" type="button" rippleEffect
                                                    (click)="SearchSenderByNumber(senderNumberPhone.value)"
                                                    [disabled]="isEditMode">Buscar</button>
                                            </div>
                                        </div>
                                        <ngb-alert [type]="'danger'"
                                            *ngIf="fs.senderPhone.hasError('required') && (fs.senderPhone.touched || fs.senderPhone.dirty)"
                                            class="mt-1" [dismissible]="false">
                                            <div class="alert-body">
                                                <span [data-feather]="'info'" [class]="'mr-50 align-middle'"></span>
                                                <span>El teléfono es requerido.</span>
                                            </div>
                                        </ngb-alert>
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label class="form-label" for="vertical-username">
                                            <b class="text-primary">*</b> Nombre y Apellidos
                                        </label>
                                        <input type="text" id="vertical-username" class="form-control"
                                            placeholder="johndoe" formControlName="senderName" />
                                        <ngb-alert [type]="'danger'"
                                            *ngIf="fs.senderName.hasError('required') && (fs.senderName.touched || fs.senderName.dirty)"
                                            class="mt-1" [dismissible]="false">
                                            <div class="alert-body">
                                                <span [data-feather]="'info'" [class]="'mr-50 align-middle'"></span>
                                                <span>El nombre es requerido.</span>
                                            </div>
                                        </ngb-alert>
                                        <ngb-alert [type]="'danger'"
                                            *ngIf="fs.senderName.hasError('pattern') && (fs.senderName.touched || fs.senderName.dirty)"
                                            class="mt-1" [dismissible]="false">
                                            <div class="alert-body">
                                                <span [data-feather]="'info'" [class]="'mr-50 align-middle'"></span>
                                                <span>El nombre solo puede contener letras.</span>
                                            </div>
                                        </ngb-alert>
                                        <ngb-alert [type]="'danger'"
                                            *ngIf="fs.senderName.hasError('maxlength') && (fs.senderName.touched || fs.senderName.dirty)"
                                            class="mt-1" [dismissible]="false">
                                            <div class="alert-body">
                                                <span [data-feather]="'info'" [class]="'mr-50 align-middle'"></span>
                                                <span>El nombre solo puede contener 60 caracteres.</span>
                                            </div>
                                        </ngb-alert>
                                    </div>
                                    <div class="col-12">
                                        <ngb-alert [type]="'warning'" *ngIf="emptyMessage" class="mt-1"
                                            [dismissible]="false">
                                            <div class="alert-body">
                                                <span [data-feather]="'info'" [class]="'mr-50 align-middle'"></span>
                                                <span>
                                                    {{emptyMessage}}
                                                </span>
                                            </div>
                                        </ngb-alert>
                                    </div>
                                </div>
                            </form>
                            <div class="d-flex justify-content-end">
                                <button class="btn btn-primary btn-next" (click)="VerticalWizardNext()" rippleEffect
                                    [disabled]="senderForm.invalid">
                                    <span class="align-middle d-sm-inline-block d-none">Siguiente</span>
                                    <i data-feather="arrow-right" class="align-middle ml-sm-25 ml-0"></i>
                                </button>
                            </div>
                        </div>
                        <div id="destination" class="content">
                            <div class="content-header">
                                <h5 class="mb-0">Destino</h5>
                                <small>Puede realizar la búsqueda por número de teléfono.</small>
                            </div>
                            <form [formGroup]="customerForm">
                                <div class="row">
                                    <div
                                        [ngClass]="{'d-none': isEditMode || !sender || sender?.customers?.length === 0, 'col-4': !isEditMode}">
                                        <button type="button" class="btn btn-primary w-100 mb-1" rippleEffect
                                            (click)="NewCustomer()">Nuevo</button>
                                        <ul class="list-group list-group-flush list-height">
                                            <a class="list-group-item list-group-item-action"
                                                *ngFor="let customerModel of sender?.customers"
                                                (click)="SelectedCustomer(customerModel)"
                                                [ngClass]="{'active': customerModel?.id == customer?.id }">
                                                {{customerModel?.name}}
                                            </a>
                                        </ul>
                                    </div>
                                    <div
                                        [ngClass]="{'col-12': isEditMode || !sender || sender?.customers?.length === 0, 'col-8': !isEditMode}">
                                        <div class="row">
                                            <div class="form-group col-md-6">
                                                <label class="form-label" for="vertical-first-name">
                                                    <b class="text-primary">*</b> Teléfono
                                                </label>
                                                <input type="number" id="vertical-first-name" (keypress)="NumberOnly($event)" maxlength="8" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" class="form-control"
                                                    placeholder="555-55555" formControlName="customerPhone"
                                                    [readonly]="isEditMode" />
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label class="form-label" for="vertical-first-name">
                                                    <b class="text-primary">*</b> Nombre y Apellidos
                                                </label>
                                                <input type="text" id="vertical-first-name" class="form-control"
                                                    placeholder="John" formControlName="customerName" />
                                                    <ngb-alert [type]="'danger'"
                                            *ngIf="fc.customerName.hasError('pattern') && (fc.customerName.touched || fc.customerName.dirty)"
                                            class="mt-1" [dismissible]="false">
                                            <div class="alert-body">
                                                <span [data-feather]="'info'" [class]="'mr-50 align-middle'"></span>
                                                <span>El nombre solo puede contener letras.</span>
                                            </div>
                                        </ngb-alert>
                                                    <ngb-alert [type]="'danger'"
                                            *ngIf="fc.customerName.hasError('maxlength') && (fc.customerName.touched || fc.customerName.dirty)"
                                            class="mt-1" [dismissible]="false">
                                            <div class="alert-body">
                                                <span [data-feather]="'info'" [class]="'mr-50 align-middle'"></span>
                                                <span>El nombre solo puede contener 60 caracteres.</span>
                                            </div>
                                        </ngb-alert>
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label class="form-label" for="vertical-country">
                                                    <b class="text-primary">*</b> Provincia
                                                </label>
                                                <ng-select [items]="states" bindLabel="name" bindValue="id"
                                                    formControlName="customerState" (change)="OnStateChange()">
                                                </ng-select>
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label class="form-label" for="vertical-language">
                                                    <b class="text-primary">*</b> Municipio
                                                </label>
                                                <ng-select [items]="cities" bindLabel="name" bindValue="id"
                                                    formControlName="customerCity">
                                                </ng-select>
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label class="form-label" for="vertical-first-name">Dirección</label>
                                                <input type="text" id="vertical-first-name" class="form-control"
                                                    placeholder="Av.42 Los Alamos" formControlName="customerAddress" />
                                            </div>
                                            <div class="form-group col-md-6">
                                                <label class="form-label" for="vertical-last-name">Punto de
                                                    Referencia</label>
                                                <input type="text" id="vertical-first-name" class="form-control"
                                                    placeholder="Detras de la terminal"
                                                    formControlName="customerReferencePoint" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                            <div class="d-flex justify-content-between">
                                <button class="btn btn-primary btn-prev" (click)="VerticalWizardPrevious()"
                                    rippleEffect>
                                    <i data-feather="arrow-left" class="align-middle mr-sm-25 mr-0"></i>
                                    <span class="align-middle d-sm-inline-block d-none">Anterior</span>
                                </button>
                                <button class="btn btn-primary btn-next" (click)="VerticalWizardNext()" rippleEffect
                                    [disabled]="customerForm.invalid">
                                    <span class="align-middle d-sm-inline-block d-none">Siguiente</span>
                                    <i data-feather="arrow-right" class="align-middle ml-sm-25 ml-0"></i>
                                </button>
                            </div>
                        </div>
                        <div id="details" class="content">
                            <div class="content-header">
                                <h5 class="mb-0">Detalles</h5>
                                <small>Recuerde subir el archivo de la factura!</small>
                            </div>
                            <form [formGroup]="detailForm">
                                <div class="row">
                                    <div class="form-group col-md-3">
                                        <label class="form-label" for="vertical-address">
                                            <b class="text-primary">*</b> Libras
                                        </label>
                                        <input type="number" id="vertical-address" maxlength="6" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" class="form-control" placeholder="0"
                                            (input)="OnChangeValue()" (keypress)="DecimalsNumberOnly($event)" formControlName="pounds" />
                                    </div>
                                    <div class="form-group col-md-3">
                                        <label class="form-label" for="vertical-landmark">
                                            <b class="text-primary">*</b> Precio por Libra
                                        </label>
                                        <input type="number" id="vertical-landmark" class="form-control" placeholder="0" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                            (input)="OnChangeValue()" maxlength="6" (keypress)="DecimalsNumberOnly($event)" formControlName="price" />
                                    </div>
                                    <div class="form-group col-md-3">
                                        <label class="form-label" for="pincode2">
                                            <b class="text-primary">*</b> Servicio
                                        </label>
                                        <input type="number" id="pincode2" maxlength="6" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" class="form-control" placeholder="0"
                                            (input)="OnChangeValue()" (keypress)="DecimalsNumberOnly($event)" formControlName="services" />
                                    </div>
                                    <div class="form-group col-md-3">
                                        <label class="form-label" for="total">
                                            <b class="text-primary">*</b> Total
                                        </label>
                                        <input type="number" id="total" class="form-control" placeholder="0" maxlength="10" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                                            (input)="OnTotalValueChanged()" (keypress)="DecimalsNumberOnly($event)" formControlName="total" />
                                    </div>
                                    <div class="form-group col-md-3">
                                        <label class="form-label" for="date-input">
                                            <b class="text-primary">*</b> Fecha del Factura:
                                        </label>
                                        <div class="input-group">
                                            <input class="form-control" placeholder="yyyy-mm-dd" name="Fecha"
                                                formControlName="createAt" ngbDatepicker #basicDP="ngbDatepicker"
                                                aria-describedby="date-input" readonly />
                                            <div class="input-group-append">
                                                <button class="btn-sm btn-outline-secondary feather icon-calendar"
                                                    (click)="basicDP.toggle()" type="button" rippleEffect></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group col-md-3">
                                        <label class="form-label" for="code">
                                            <b class="text-primary">*</b> Código:
                                        </label>
                                        <input type="text" id="code" maxlength="8" class="form-control" placeholder="Código Factura"
                                            formControlName="code" />
                                    </div>
                                    <fieldset class="form-group col-md-3">
                                        <label for="file-upload-multiple">
                                            <b class="text-primary"></b> Factura:
                                        </label>
                                        <div class="custom-file">
                                            <input type="file" class="custom-file-input" type="file" ng2FileSelect
                                                id="file-upload-multiple" (change)="LoadFile($event)" />
                                            <label class="custom-file-label">
                                                {{ isEditMode ? billDocName : billDoc?.name ?? 'Factura' }}
                                            </label>
                                        </div>
                                    </fieldset>
                                    <div
                                        class="custom-control custom-switch col-md-3 d-flex justify-content-center align-items-center pt-1">
                                        <input type="checkbox" class="custom-control-input" id="sms"
                                            formControlName="sendSMS" />
                                        <label class="custom-control-label" for="sms">Recibe SMS?</label>
                                    </div>
                                </div>
                            </form>
                            <div class="d-flex justify-content-between">
                                <button class="btn btn-primary btn-prev" (click)="VerticalWizardPrevious()"
                                    rippleEffect>
                                    <i data-feather="arrow-left" class="align-middle mr-sm-25 mr-0"></i>
                                    <span class="align-middle d-sm-inline-block d-none">Aterior</span>
                                </button>
                                <button class="btn btn-primary btn-next" (click)="VerticalWizardNext()" rippleEffect
                                    [disabled]="detailForm.invalid">
                                    <span class="align-middle d-sm-inline-block d-none">Siguiente</span>
                                    <i data-feather="arrow-right" class="align-middle ml-sm-25 ml-0"></i>
                                </button>
                            </div>
                        </div>
                        <div id="confirmation" class="content">
                            <div class="content-header">
                                <h5 class="mb-0">Confirmación</h5>
                                <small>Revise todos los datos antes de enviar.</small>
                            </div>
                            <div class="col-12">
                                <div class="row mb-3">
                                    <div class="col-5">
                                        <h5 class="mb-0">Origen:</h5>
                                        <hr>
                                        <p class="card-text">Nombre: <b>{{fs.senderName.value}}</b></p>
                                        <p class="card-text">Teléfono: <b>{{fs.senderPhone.value}}</b></p>

                                        <h5 class="mb-0 mt-2">Destino:</h5>
                                        <hr>
                                        <p class="card-text">Teléfono: <b>{{fc.customerPhone.value}}</b></p>
                                        <p class="card-text">Nombre: <b>{{fc.customerName.value}}</b></p>
                                        <p class="card-text">Provincia:
                                            <b>{{GetStateNameById(fc.customerState.value)}}</b>
                                        </p>
                                        <p class="card-text">Municipio:
                                            <b>{{GetCityNameById(fc.customerCity.value)}}</b>
                                        </p>
                                        <p class="card-text">Dirección: <b>{{fc.customerAddress.value}}</b></p>
                                        <p class="card-text">Referencia: <b>{{fc.customerReferencePoint.value}}</b></p>
                                    </div>
                                    <div class="col-3">

                                    </div>
                                    <div class="col-4">
                                        <h5 class="mb-0">Detalle:</h5>
                                        <hr>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <p class="card-text text-right">Código:</p>
                                            <p class="card-text text-right"><b>{{fd.code.value}}</b></p>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <p class="card-text text-right">Libras: </p>
                                            <p class="card-text text-right"><b>{{fd.pounds.value}}</b></p>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <p class="card-text text-right">Precio x Libra:</p>
                                            <p class="card-text text-right"><b>{{fd.price.value | currency}}</b></p>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <p class="card-text text-right">Servicio:</p>
                                            <p class="card-text text-right"><b>{{fd.services.value | currency}}</b></p>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <p class="card-text text-right">Total:</p>
                                            <p class="card-text text-right"><b>{{fd.total.value | currency}}</b></p>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div class="d-flex justify-content-between">
                                <button class="btn btn-primary btn-prev" (click)="VerticalWizardPrevious()"
                                    rippleEffect>
                                    <i data-feather="arrow-left" class="align-middle mr-sm-25 mr-0"></i>
                                    <span class="align-middle d-sm-inline-block d-none">Anterior</span>
                                </button>
                                <button class="btn btn-success btn-submit" rippleEffect
                                    (click)="CreateBill()">{{isEditMode ? 'Editar' : 'Crear'}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>